import { render, staticRenderFns } from "./juridicalPersonLifeCount.vue?vue&type=template&id=5940a05e&scoped=true&"
import script from "./juridicalPersonLifeCount.vue?vue&type=script&lang=js&"
export * from "./juridicalPersonLifeCount.vue?vue&type=script&lang=js&"
import style0 from "./juridicalPersonLifeCount.vue?vue&type=style&index=0&id=5940a05e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940a05e",
  null
  
)

export default component.exports